import type { ApplicationEnum } from "~/@types/enums";
import type { ModuleBranding } from "~/layout/useModuleBranding";

export const moduleBrandingConfig: Partial<Record<ApplicationEnum, Partial<ModuleBranding>>> = {};

export default moduleBrandingConfig;
